// Single source for the current page host (subdomain.domain.tld). Shown to users as a trust cue
// (address-bar / camera-access messaging) and matched against configured host lists.
export const hostname = typeof window !== "undefined" ? window.location.hostname : "";
